import confetti from "canvas-confetti";

// Celebration confetti burst
export const celebrateConfetti = () => {
  const duration = 3000;
  const end = Date.now() + duration;

  const colors = ["#52796F", "#C9AE5D", "#ffffff", "#FFD700"];

  const frame = () => {
    confetti({
      particleCount: 3,
      angle: 60,
      spread: 55,
      origin: { x: 0, y: 0.7 },
      colors: colors,
    });

    confetti({
      particleCount: 3,
      angle: 120,
      spread: 55,
      origin: { x: 1, y: 0.7 },
      colors: colors,
    });

    if (Date.now() < end) {
      requestAnimationFrame(frame);
    }
  };

  frame();
};

// Quick burst for form submission
export const quickCelebration = () => {
  confetti({
    particleCount: 100,
    spread: 70,
    origin: { y: 0.6 },
    colors: ["#52796F", "#C9AE5D", "#ffffff", "#FFD700"],
  });
};

// Stars celebration for quiz completion
export const starsCelebration = () => {
  const defaults = {
    spread: 360,
    ticks: 100,
    gravity: 0.5,
    decay: 0.94,
    startVelocity: 30,
    shapes: ["star"],
    colors: ["#C9AE5D", "#FFD700", "#FFF8DC"],
  };

  confetti({
    ...defaults,
    particleCount: 50,
    scalar: 1.2,
    origin: { x: 0.5, y: 0.5 },
  });

  setTimeout(() => {
    confetti({
      ...defaults,
      particleCount: 30,
      scalar: 0.75,
      origin: { x: 0.3, y: 0.6 },
    });
  }, 150);

  setTimeout(() => {
    confetti({
      ...defaults,
      particleCount: 30,
      scalar: 0.75,
      origin: { x: 0.7, y: 0.6 },
    });
  }, 300);
};

export default { celebrateConfetti, quickCelebration, starsCelebration };
